import styled, { css, keyframes } from 'styled-components';

// @TODO: анимация кнопок при нажатии
const buttonKeyframes = keyframes`
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
	100% {
		opacity: 1;
	}
`;

const TabButton = styled.div<{ $fixed?: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	flex-grow: 0;
	min-width: 20px;
	min-height: 20px;
	${({ $fixed }) =>
		$fixed &&
		css`
			width: 20px;
			height: 20px;
		`}
	padding: 4px 6px;
	border-radius: 6px;
	background-color: #fff;
	user-select: none;

	font-family: 'GT Walsheim Pro';
	font-size: 10px;
	font-weight: bold;
	color: #262628;

	animation-name: ${buttonKeyframes};
	animation-duration: 0.5s;
	animation-timing-function: ease;
	animation-iteration-count: 1;

	img {
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
	}
`;

export { TabButton };
